module.exports = __webpack_public_path__ + "static/interior_on_left-11232ad8b428a080512493dadb106497.webp";